import { gql } from '@apollo/client';

const ReturnFromWorldpayMutation = gql`
  mutation ReturnFromWorldpay(
    $cartId: ID
    $orderKey: String!
    $paymentAmount: String!
    $paymentCurrency: String!
    $paymentStatus: String!
    $mac: String!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        returnFromWorldpay(
          orderKey: $orderKey
          paymentAmount: $paymentAmount
          paymentCurrency: $paymentCurrency
          paymentStatus: $paymentStatus
          mac: $mac
        ) {
          id
          reservedOrderNumber
          state
        }
      }
    }
  }
`;

export default ReturnFromWorldpayMutation;
